module.exports = __webpack_public_path__ + "img/schedule.bf47922c.svg";